import { useMemo } from "react";
import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { AffectedProfileType } from "~/graphql/supergraphTypes";
import {
  affectedProfileContainer,
  moreText,
  profileNameText,
  tooltipContentWrapper,
} from "./styles_vanilla.css";

export interface AffectedProfileRendererProps {
  value: AffectedProfileType[];
}

export const AffectedProfileRenderer = ({ value }: AffectedProfileRendererProps) => {
  const [firstProfile, ...remainingProfiles] = value || [];
  const hasMultipleProfiles = remainingProfiles.length > 0;

  const tooltipContent = useMemo(
    () => (
      <div className={tooltipContentWrapper}>
        {remainingProfiles.map((profile) => (
          <span key={profile.profileId}>{profile.name}</span>
        ))}
      </div>
    ),
    [remainingProfiles],
  );

  if (!value || value.length === 0) return null;

  return (
    <Flex className={affectedProfileContainer} gap={Sizes.XS}>
      <Text variant="strong-md" className={profileNameText}>
        {firstProfile.name}
      </Text>
      {hasMultipleProfiles && (
        <HelpIndicator id="affected-profile-tooltip" placement="top" content={tooltipContent}>
          <Flex flexDirection="row" gap={Sizes.XS}>
            <Text variant="strong-md">+</Text>
            <Text variant="strong-md" className={moreText}>
              {remainingProfiles.length} more
            </Text>
          </Flex>
        </HelpIndicator>
      )}
    </Flex>
  );
};
